import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  ACTIVOSFIJOS_INVENTARIOS_LISTA,
  ACTIVOSFIJOS_INVENTARIOS_NUEVO,
  ACTIVOSFIJOS_INVENTARIOS_EDITAR
} from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'
import EditarPage from './editar'

export default function ActivosFijosInventariosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ACTIVOSFIJOS_INVENTARIOS_LISTA}`} component={ListaPage} />
        <Route path={`/${ACTIVOSFIJOS_INVENTARIOS_NUEVO}`} component={NuevoPage} />
        <Route path={`/${ACTIVOSFIJOS_INVENTARIOS_EDITAR}/:idInventario`} component={EditarPage} />
      </Switch>
    </Suspense>
  )
}
